import type { FilterPanelSelectOptions } from "./types";

export const filterPanelSelectOptions: FilterPanelSelectOptions = ({
  options,
  query,
}) => {
  const needle = query.trim().toLowerCase();
  if (!needle) return options;
  // Label only, never the circuit id: the ids are internal ("c-9"), so typing
  // a letter would match runs whose printed name has nothing to do with it.
  return options.filter((option) =>
    option.label.toLowerCase().includes(needle),
  );
};
